import React from 'react';
import QuantitySelector from '../commons/quantity-selector/QuantitySelector';
import ProductDefaultImage from '../../assets/images/product-default-image.jpg'

const ProductList = ({products, onChangeProductQuantity, onDeleteProduct, viewMode}) => {

  return (
    <table className="table product-list-table table-responsive">
      <thead>
        <tr>
          <td className="title-col">Products</td>
          <td>Item Price</td>
          <td>Quantity</td>
          <td>Total</td>
          {viewMode && viewMode === 'edit'
            ? (
              <td>&nbsp;</td>
            )
            : null}

        </tr>
      </thead>
      <tbody>
        {products && products.map((p, idx) => {
          const product = {...p};
          // sort by quantity in descending
          const discounts = product.QuantityDiscount && product.QuantityDiscount
            .sort((a, b) => b.quantity - a.quantity);

          if (discounts && discounts.length > 0) {
            product.bundledDiscount = product.QuantityDiscountOddItems ?
            discounts.filter(d =>
              d.quantity <= product.quantity) ?
                discounts.filter(d => d.quantity <= product.quantity)[0]
                : undefined
              : discounts.find(d => d.quantity === product.quantity);

            if (product.bundledDiscount) {
              product.SalePrice = product.bundledDiscount.priceB;
              product.bundle = true;
            } else {
              product.bundle = false;
            }
          }

          return (
            <tr key={`product_${idx}`}>
              <td className="title-col">
                <div className="thumb"><img src={product.image
              ? product.image
              : ProductDefaultImage} alt="product thumbnail" onError={(e) => {
                  return e.target.src = ProductDefaultImage
                }}/></div>
              <a href={`/products/${product._id}`}><span>{product && product.Description
                        ? product['Sub Description 2'] ? product['Sub Description 3'] ? product.Description + ' ' + product['Sub Description 2'] + ' ' + product['Sub Description 3']:product.Description + ' ' + product['Sub Description 2']: product.Description:''}</span></a>
              </td>
              <td>
                <span>
                {product.PriceB && !(product.OnSale || product.bundle)
                    ? `$${ parseFloat(product.PriceB).toFixed(2)}`
                    : ''}
                {product.PriceB && (product.OnSale || product.bundle)
                    ? <span><s>{`$${ parseFloat(product.PriceB).toFixed(2)}`}</s> {`$${ parseFloat(product.SalePrice).toFixed(2)}`}</span>
                    : ''}
                  </span>
              </td>
              <td className="quantity-col">
                {viewMode && viewMode === 'edit'
                  ? (<QuantitySelector quantity={product.quantity
                    ? product.quantity
                    : 0} onChangeQuantity={(qty) => onChangeProductQuantity(product, qty)} minimumQuantity={1}/>)
                  : product.quantity}</td>
              <td>
                <span>
                {product.PriceB && product.quantity && !(product.OnSale || product.bundle)
                    ? `$${ (parseFloat(product.PriceB) * parseFloat(product.quantity)).toFixed(2)}`
                    : ''}
                {(product.OnSale || product.bundle) && product.quantity
                    ? <span><s>{`$${ (parseFloat(product.PriceB) * parseFloat(product.quantity)).toFixed(2)}`}</s> {`$${ (parseFloat(product.SalePrice) * parseFloat(product.quantity)).toFixed(2)}`}</span>
                    : ''}
                </span>
              </td>
              {viewMode && viewMode === 'edit'
                ? (
                  <td className="buttons-col" onClick={(e) => onDeleteProduct ? onDeleteProduct(product._id) : null}><i className="fa fa-trash-o delete-product-button"/></td>
                )
                : null}

            </tr>
          )
        })}
      </tbody>
    </table>
  );
};

export default ProductList;



// WEBPACK FOOTER //
// ./src/components/cart/ProductList.js